var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-contianer",staticStyle:{"padding-bottom":"0"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imgUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }